import React, { useCallback, useMemo, useState } from "react";
import styled from "@emotion/styled";
import {
  Button,
  Table,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { IconPlus } from "@tabler/icons-react";
import Pagination from "../../../components/Pagination";
import SubCard from "../../../components/cards/SubCard";
import NoResultFound from "../../../components/NoResultFound";
import { useModal } from "mui-modal-provider";
import AddPriorPayment from "./AddPriorPayment";
import usePayment from "../../../../hooks/usePayment";

const CustomTableRow = styled(TableRow)(() => ({
  height: "50px",
}));

const CustomTableCell = styled(TableCell)(() => ({
  paddingTop: 0,
  width: 130,
  paddingBottom: 0,
  // fontSize: "15px",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

const PriorPayment = ({ caseData, isCaseClosed }: any) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { showModal } = useModal();
  const { paymentScheduling } = usePayment(caseData?._id);

  const isPaymentCompleted = useMemo(() => {
    return paymentScheduling?.payment?.every(
      (payment: any) => payment.isPaymentCompleted === true
    );
  }, [paymentScheduling]);

  const paginatedPayments = caseData?.priorPayment?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handlePriorPayment = useCallback(() => {
    const modal: any = showModal(AddPriorPayment, {
      onClose: () => modal.hide(),
      caseData,
      caseId: caseData?._id,
    });
  }, [showModal, caseData]);
  return (
    <SubCard
      title={"Prior Payment"}
      secondary={
        <>
          {caseData?.representingInfo?.continueRepresentingThisCase === "yes" ||
          !isPaymentCompleted ||
          isCaseClosed ? (
            <Tooltip
              title={
                caseData?.representingInfo?.continueRepresentingThisCase ===
                "yes"
                  ? "Cannot add prior payment representation is ongoing"
                  : !isPaymentCompleted
                    ? "Add only before payment schedule is created, as it affects the fee calculation."
                    : "Disabled because case is closed."
              }
            >
              <span>
                <Button
                  sx={{ color: "green", cursor: "pointer" }}
                  onClick={handlePriorPayment}
                  disabled
                >
                  <IconPlus />
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button
              sx={{ color: "green", cursor: "pointer" }}
              onClick={handlePriorPayment}
            >
              <IconPlus />
            </Button>
          )}

          {/* <Button
            sx={{
              color: "green",
              cursor: "pointer",
            }}
            onClick={handlePriorPayment}
            disabled={
              caseData?.representingInfo?.continueRepresentingThisCase ===
                "yes" ||
              !isPaymentCompleted ||
              isCaseClosed
            }
          >
            <IconPlus />
          </Button> */}
        </>
      }
    >
      {!!paginatedPayments?.length ? (
        <>
          <Table>
            <CustomTableRow>
              <CustomTableCell>
                <Typography variant="h5">Paid On</Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="h5">Payment Method</Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="h5">Amount</Typography>
              </CustomTableCell>
            </CustomTableRow>
            {paginatedPayments?.map((payment: any, i: number) => {
              return (
                <CustomTableRow key={i}>
                  <CustomTableCell>
                    {moment(payment?.paidDate).format("MM/DD/YYYY")}
                  </CustomTableCell>
                  <CustomTableCell sx={{ textTransform: "capitalize" }}>
                    {payment?.type}
                  </CustomTableCell>
                  <CustomTableCell>{`$ ${Number(payment?.amount)?.toFixed(2)}`}</CustomTableCell>
                </CustomTableRow>
              );
            })}
          </Table>
          <Pagination
            component="div"
            count={caseData?.priorPayment?.length || 0}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </>
      ) : (
        <NoResultFound>No Balance found</NoResultFound>
      )}
    </SubCard>
  );
};

export default PriorPayment;
